/**
 * Dashboard Admin - React Vite
 */

import { useNavigate } from 'react-router-dom';
import { Users, Shield, Activity, Settings } from 'lucide-react';

export function DashboardPage() {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Gestion des utilisateurs',
      description: 'Gérer les comptes utilisateurs, rôles et permissions',
      icon: Users,
      path: '/admin/users',
      color: 'bg-primary',
    },
    {
      title: 'Sécurité',
      description: 'Paramètres de sécurité et gestion des IP',
      icon: Shield,
      path: '/admin/security',
      color: 'bg-danger',
    },
    {
      title: 'Activité',
      description: 'Logs d\'activité et audit',
      icon: Activity,
      path: '/admin/activity',
      color: 'bg-success',
    },
    {
      title: 'Paramètres',
      description: 'Configuration générale du système',
      icon: Settings,
      path: '/admin/settings',
      color: 'bg-primary-hover',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-content">
          Tableau de bord Administration
        </h1>
        <p className="mt-1 text-sm text-content-muted">
          Bienvenue dans l'interface d'administration
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {menuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="p-6 bg-surface rounded-lg shadow-md hover:shadow-lg
                     transition-all text-left group"
          >
            <div className={`inline-flex p-3 rounded-lg ${item.color} text-content-inverted mb-4
                          group-hover:scale-110 transition-transform`}>
              <item.icon className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-semibold text-content">
              {item.title}
            </h3>
            <p className="mt-1 text-sm text-content-muted">
              {item.description}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}

export default DashboardPage;
